import { ExclamationMarkHexagonIcon } from '@grupoboticario/flora-react-icons';
import { Link } from 'react-router-dom';

import { ResponsiveFloraTypography } from 'components';
import config from 'config';
import { BusinessUnit } from 'domains/brand.d';
import { useTracking } from 'hooks';
import { useGlobalContext } from 'store';

import Styles from '../../Detail.styles';

export const MessageInfo = () => {
  const { sendDataToGTM } = useTracking();
  const isEud = config.app.short === BusinessUnit.EUD;
  const {
    user: { isMultiBrand },
  } = useGlobalContext();
  const isEudAndVDF = isEud && isMultiBrand;
  const linkPortalMultBrand =
    'https://revendedor.boticario.com.br/perfil?utm_source=portal_eud&utm_medium=aviso_multimarcas_perfil&utm_content=acessar_portal_multimarcas';

  const handleTracking = () => {
    sendDataToGTM({
      event: 'analytics-event',
      event_parameters: {
        event_name: 'interaction_perfil',
        cd_interaction_detail: 'click:acessar-portal-multimarcas',
      },
    });
  };

  if (!isEudAndVDF) {
    return null;
  }

  return (
    <Styles.MessageInfoWrapper direction='column'>
      <Styles.Tag>
        <ExclamationMarkHexagonIcon size={24} />
        <ResponsiveFloraTypography fontSize='bodyLargeShort'>
          Acesse o portal multimarcas,{' '}
          <Link to={linkPortalMultBrand} target='_blank' rel='noopener noreferrer'>
            <ResponsiveFloraTypography
              onClick={handleTracking}
              color='$backgroundAltPrimary'
              fontSize='bodyLargeShort'
              fontWeight='regular'
              textDecoration='underline'
              as='span'
            >
              Revendedor O Boticário
            </ResponsiveFloraTypography>
          </Link>{' '}
          para alterar seus dados.
        </ResponsiveFloraTypography>
      </Styles.Tag>
    </Styles.MessageInfoWrapper>
  );
};

export default MessageInfo;
